import 'react-widgets/dist/css/react-widgets.css';
import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import {Icon, Checkbox, Button, Modal, Dropdown, Grid, Card, Message, TextArea, Container, Input, Divider, Popup, Tab, Radio, Search} from 'semantic-ui-react';
import momentLocalizer from 'react-widgets-moment';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import Calendar from 'react-widgets/lib/Calendar'
import moment from 'moment-timezone'

// ...Or if you prefer to use the Less or Sass files directly
// import 'react-widgets/lib/less/react-widgets.less';
// import 'react-widgets/lib/scss/react-widgets.scss';
import defaultObjectiveImage from 'img/default-challenge-image.jpg';
import {getCompetitionImageUrl } from '../tools.js';
import Utils from 'utils/Utils.js'
import LoadInline from 'modules/loading/LoadInline.js';
import ChallengeCard from '../ChallengeCard.js';
import CategoryCard from '../CategoryCard.js';
import DeletePromptContainer from 'modules/misc/DeletePromptContainer.js'
import ChoosePhotoContainer from 'modules/misc/ChoosePhotoContainer.js';
import {colors, fontSizes, fonts, spacings, shadow, buttons} from 'style';
import RoleUtils from 'utils/RoleUtils'
//import styleDef from './style.js';
import defaultCategoryImage from 'img/default-challenge-image.jpg';

momentLocalizer(moment)

var style = {
    //...styleDef,
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'

    },
    content: {

    },
    checkbox: {
        marginRight: spacings.tiny,
    },
    header: {
        ...fonts.h3,
        color: colors.themeDarkerGrey,
    },
    subheader: {
        ...fonts.h4,
        color: colors.themeDarkerGrey,
    },
    description: {
        ...fonts.bodyL,
        lineHeight: '1.5',
        padding: spacings.base,
        textAlign: 'left',
        color: colors.themeDarkerGrey,
    },
    columns: {
    },
    textarea: {
        resize: 'vertical',
        minHeight: '100px',
        width: '100%',
        borderRadius: '4px',
        border: '1px solid rgba(34, 36, 38, 0.15)',
    },
    fullWidthInput: {
        width: '100%',
    },
    leftColumn: {
        display: 'inline-block',
        width: '33%',
        verticalAlign: 'top',
    },
    rightColumn: {
        display: 'inline-block',
        width: '67%',
        verticalAlign: 'top',
    },
    challengeList: {
        overflowY: 'auto',
        height: '300px',
    },
    challengeImage: {
        position: 'absolute',
        left: '-45px',
        top: '10px',
        height: '40px',
        width: '60px',
        backgroundSize:'100%',
        backgroundPosition: '50% 50%',
        backgroundRepeat: 'no-repeat',
        
        borderRadius: '6px',
        boxShadow: shadow,
    },
    challengeRow: {
        position: 'relative',
        marginLeft: '50px',
        height: '60px',
        paddingTop: '10px',
        paddingBottom: '10px',
    },
    challengeTitle: {
        textAlign: 'center',
        fontWeight: 'bold',
    },
    bannerImage: {
        marginTop: '50px',
        width: '150px',
        borderRadius: '6px',
        boxShadow: shadow,
    },
    button: {
        //marginLeft: spacings.small,
        //marginRight: spacings.small,
        ...buttons.base,
    },

    button3: {
        //marginLeft: spacings.small,
       // marginRight: spacings.small,
        ...buttons.secondary,
        ...buttons.shortWidth,
    },
    gridSubmit : {
        textAlign : 'right'
    },
    h4 : {
        ...fonts.h4,
        color : colors.themeBlue,
        marginTop : spacings.base,
        marginBottom : spacings.base
    },
    body : {
        ...fonts.bodyL,
        color : colors.themeDarkerGrey
    },
    back : {
       fontSize: fontSizes.h4,
       //position: 'absolute',
       color: colors.themeDarkerGrey,
       cursor: 'pointer'
    },
    starIcon : {
        color: colors.pointsYellow,
        verticalAlign: 'baseline'
    },
    resourcesIcon : {
        color: colors.pointsBlue,
    },
    teamIcon: {
        fontSize: '20px',
        top: '-2px',
        left: '12px',
        position: 'absolute',
    },
    image: {
        position: 'absolute',
        boxShadow: shadow,
        borderRadius: '9px',
        width: '40px',
        height: '40px',
        top: '-10px',
        left: '2px'
        // backgroundSize:'cover',
        // backgroundPositionX: 'center',
        // backgroundPositionY: 'center',
        // backgroundRepeat: 'no-repeat',
    },
    pointsCell : {
        padding : '0px'
    },
    teamSegmentRow: { listStyle: 'none',
        borderTop: '1px solid ' + colors.themeDarkGrey,
        paddingTop: spacings.tiny,
        paddingBottom: spacings.tiny,
    },
    removeTeamSegmentButton: {
        float: 'right',
        border: 'none',
        boxShadow: 'none',
        padding: '0',
        margin: '4px 8px 0 8px',
        color: colors.warningRed,
        backgroundColor: '#fff',
        fontSize: '20px',
    },
    slimRow : {
        paddingBottom: spacings.micro,
        paddingTop :spacings.micro
    },
    buttonsRow: {
        marginTop:spacings.large
    },
    banner: {
        width: '100%',
        //borderTopRightRadius: '9px',
        //borderTopLeftRadius: '9px',
        aspectRatio: 16 / 9,
        //height: '300px',
        objectFit: 'cover'
    },
    bannerText : {
        position: "absolute",
        bottom: "0",
        left: "0",
        textAlign : 'center',
        width: "100%",
        padding:spacings.tiny
    },
    segmentList: {
        height: '275px',
        overflowY: 'scroll',
        paddingLeft: '0px',
    },
    segmentRow: {
        listStyle: 'none',
        borderTop: '1px solid ' + colors.themeDarkGrey,
        paddingTop: spacings.tiny,
        paddingBottom: spacings.tiny,
    },
    addButton: {
        float: 'right',
        border: 'none',
        boxShadow: 'none',
        padding: '0',
        margin: '4px 8px 0 8px',
        color: colors.themeBlue,
        backgroundColor: '#fff',
        fontSize: '20px',
    },
    segmentName: {
        //fontWeight: 'bold',
        display: 'inline-block',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        marginLeft: spacings.base,
    },
    bannerTextTitle : {
        color: colors.themeWhite,
        fontSize: fontSizes.h3,
    },
    bannerTextDescription : {
        color: colors.themeDarkGrey,
        fontSize: fontSizes.body,
    },
    contentPic: {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: '800px',
        lineHeight: '1.5',
        ...fonts.body,
    },
    segment: {
        backgroundColor: 'white',
        borderRadius: '9px',
        //boxShadow: shadow,
        margin: '-1.5rem',
        //textAlign: 'center',
    },
    cardContent: {
        padding: spacings.base,
    },
    competitionTitle: {
        paddingTop: '0',
        paddingBottom: '0',
    },
    checkmark: {
        color : colors.themeTeal,
    },
    checkmarkDim: {
        color : colors.themeDarkGrey1_2,
    },
    h3: {
        fontSize: fontSizes.h3,
        color: colors.themeBlue,
        padding: spacings.base,
    },
    numberInput : {
        //width:'150px',
        //padding:0
    },
    inputStyle : {width:'125px'},
    slider  : {verticalAlign:'middle', marginLeft : spacings.small, marginRight : spacings.small},
    uploadPhoto: {
        display: 'inline-block',
        marginLeft: spacings.small,
        marginRight: spacings.small,
        ...buttons.base,
    },
    shareThemeFlex: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(160px, 1fr))',
        gap: '1rem',
        margin: '1rem 0',
    },
    shareThemeColumn: {
        minWidth: '160px',
        textAlign: 'center',
    },
    shareThemePreview: {
        display: 'block',
        boxShadow: shadow,
        borderRadius: '9px',
        width: '160px',
        height: '160px',
        objectFit: 'contain',
        margin: '0 auto 0.5rem',
    },
    shareThemeColors: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '1rem',
        margin: '0.5rem 0 1rem',
    },
    shareThemeColorField: {
        minWidth: '140px',
    },

};

// Pre-launch
// - This email will be sent before the contest begins to outline contest details.
// Launch
// - This email communicates that the contest starts today.
// Second Wave
// - This email is sent to all employees that have not yet enrolled in the contest encouraging them to join.
// End of challenge
// - This email is sent to all contest participants with the final results.

var announcementTypes = {
    0 : { label : 'Custom email', info: '', getMax: function(){}, getMin: function(){}},
    1 : { label : 'Pre-launch email', info: 'This email will be sent before the contest begins to outline contest details. It is recommended to send this 7 days prior to the challenge start date.', getMax: function(season){return season.startsAt}, getMin: function(season){}},
    2 : { label : 'Launch email', info: 'This email communicates that the contest starts today. It is recommended to send this on the date the challenge begins.', getMax: function(season){return season.endsAt}, getMin: function(season){return season.startsAt}},
    3 : { label : 'Second wave email', info: 'This email is sent to all employees that have not yet enrolled in the contest encouraging them to join. It is recommended to send this 7 days after the challenge start date.', getMax: function(season){return season.endsAt}, getMin: function(season){return season.startsAt}},
    4 : { label : 'End of challenge email', info: 'This email is sent to all members with the final results. It is recommended to send this the day after the challenge ends.', getMax: function(season){}, getMin: function(season){return season.endsAt}}
}

const sections = {
    EMAIL: 'email',
}

const accessMap = {
    admin: [
        sections.EMAIL
    ],
    'corporate wellness': [
    ],
    'corporate wellness standard': [
    ]
}


const MileStone = ({
    t,
    milestone,
    prop,
    edit,
    index,
    activeColumn,
    onChangeRankPoints
}) => {
    const isActiveMetric = prop === activeColumn
    const hasValue = !!milestone[prop]
    const show = (edit && isActiveMetric) || hasValue
    return show && <div>{edit ?
        <Input 
            style={{...style.numberInput}}
            input={<input style={style.inputStyle}/>}
            name='points' 
            type='number' value={ prop === 'duration' ? (milestone[prop] != null && milestone[prop] !== '' ? Math.floor(Number(milestone[prop])/60) : '') : (prop === 'distance' ? (milestone[prop] != null && milestone[prop] !== '' ? Number(milestone[prop])/1000 : '') : (milestone[prop] ?? '')) } 
            onChange={(e, p)=>{onChangeRankPoints(e, { ...p, value : prop === 'duration' ? (p.value === '' || p.value == null ? '' : p.value * 60) : (prop === 'distance' ? (p.value === '' || p.value == null ? '' : p.value * 1000) : p.value) }, 'milestones['+index+'].'+prop)}}
            label={t(prop)}
            labelPosition='right'
        />
        : <span>{prop === 'duration' ? Math.floor(milestone[prop]/60) : (prop === 'distance' ? milestone[prop]/1000 : milestone[prop])} {t(prop)}</span> } 
        </div>
};

const hasLocaleContent = (loc) => loc && (loc.infoContent != null || loc.rulesContent != null || loc.seasonContent != null)

const ShareableLanguagePane = ({ t, season, locale, onChange }) => (
    <div>
        <br />
        <Input
            fluid
            value={season.leaderboard?.locales?.[locale]?.shareableTitle || ''}
            name={'season.leaderboard.locales.' + locale + '.shareableTitle'}
            onChange={onChange}
            onFocus={onChange}
            label={t('shareable_title_label')}
            maxLength="100"
            style={style.fullWidthInput}
        />
        <br />
    </div>
);

const LanguagePane = ({t, season, seasonData, competitionData, competition, locale, onChange}) => {
    const localeHasContent = competition?.locales && hasLocaleContent(competition.locales[locale])
    return (
    <div>
        <br/>
       <div>
     <Input  fluid
             value={(competitionData && competitionData.title) || (season.leaderboard?.locales?.[locale]?.title) || ''} 
             name= {'season.leaderboard.locales.'+locale+'.title'}
             onChange={onChange}
             onFocus={onChange}
             label='Challenge Title:'
             maxLength = "100"
             style={style.fullWidthInput}/>
       </div> 
       <div> 
            <Input  fluid
             value={(seasonData && seasonData.title) || (season.locales?.[locale]?.title) || ''} 
             name= {'season.locales.'+locale+'.title'}
             onChange={onChange}
             onFocus={onChange}
             label='Sub Title:'
             maxLength = "100"
             style={style.fullWidthInput}/>
     
     </div>

     <div> 
            <TextArea  value={(seasonData && seasonData.description) || (season.locales?.[locale]?.description) || ''} 
             name= {'season.locales.'+locale+'.description'}
             onChange={onChange}
             onFocus={onChange}
             style={style.textarea}
             label='Description:'
             maxLength = "800"/>
            {localeHasContent && (
                <Message warning style={{ marginTop: 8 }}>
                    {t('competitionHasContentWarning')}
                </Message>
            )}
     
     </div>
       <br/>
    </div>
);
};

const EditCompetitionModal = ({
    t,
    now,
    busy,
    languages,
    season,
    competition,
    competitions,
    announcements,
    milestones,
    categories,
    teams,
    rewards,
	competitionOptions,
	onClose,
    onDateChange,
    onDelete,
    onSubmit,
    onEndCompetition,
    onClickCompetition,
    onClickChange,
    deleteModalRef,
    onToggleCategory,
    onChangeRankPoints,
    onChangeCheckbox,
    onChangeTeamCheckbox,
    onChangeSearch,
    onTimeZoneChange,
    onPreEnrollNowChange,
    onStartNowChange,
    onEndNowChange,
    preEnrollNow,
    startNow,
    endNow,
    dateError,
    onAddSegmentTeam,
    onRemoveSegmentTeam,
    onAddMilestone,
    roles,
    loadingTeamSegments,
    addedTeamsSegments,
    teamsSegments,
    onLanguageInputChange,
    localeTabIndex,
    onLocaleTabChange,
    onUploadPhoto,
    onUploadThemePhoto,
    onRemoveThemeAsset,
    onChangeShareableLeaderboard,
    onChangeLeaderboardShowCompanyName,
    onConfirmPhoto,
    choosePhotoIsOpen,
    themeUploadProperty,
    uploading,
    onExport,
    onDeleteCompetition,
    seasonQuizDraft,
    surveySearchResults,
    surveySearchLoading,
    surveySearchQuery,
    onSurveySearchChange,
    onAddSeasonQuizFromSurvey,
    onRemoveSeasonQuiz,
    onMoveSeasonQuiz,
}) => {
    const checkAccess = (section) => {
        return RoleUtils.checkUIAccess(roles, accessMap, section)
    }
    return (
        <Modal open style={style.content} onClose={onClose} size={season.id || competition ? 'small' : 'large'}>
            <Modal.Header style={style.modalHeader}>
            {competition && !season.id && <Icon style={style.back} onClick={!season.id && onClickChange} name="chevron left"/>}
            {t(season && season.id ? 'Update Competition' : 'Schedule New Competition')}
            {competition && onExport && localStorage.master ==='true' &&
                <Button
                    style={style.editButton}
                    className="categories-editButton"
                    onClick={() => onExport(competition)}
                    
                    >
                    <Icon style={style.editIcon} name='download' />
                    {t('export')}
                </Button>
            }
            </Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    {busy &&
                        <LoadInline centered vcentered className='notInDimmer' /> 
                    }
                    {!busy &&
                        <div>
                            
                            {!competition && competitions && !!competitions.length &&
                                <Card.Group>
                                    {competitions.map(function(competition) {
                                        return <ChallengeCard
                                            key={competition.id}
                                            competition={competition}
                                            onClick={(event)=>onClickCompetition(event, competition.id)}
                                            onExport={onExport}
                                            onDelete={onDeleteCompetition}
                                            //centered={true}
                                        />
                                    })}
                                </Card.Group> }
                            { competition && 
                                <div>
                                        
                        
                                                {/* <ChallengeCard
                                                    key={competition.id}
                                                    competition={competition}
                                                    onClick={(event)=>onClickCompetition(event, competition.id)}
                                                    centered={true}
                                                /> */}
                                                {/* <div style={{...style.banner, backgroundImage:"linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), " + Utils.url(getCompetitionImageUrl({competition}))}}>
                                                    <div style={style.bannerText}>
                                                        <div style={style.bannerTextTitle}>Step Together</div>
                                                        <div style={style.bannerTextDescription}><Icon style={style.checkmark} name={(competition.leaderboard || competition).type == 'teams' ? 'users' : 'user'}/>
                {(competition.leaderboard || competition).type == 'teams' ? t('Team Competition') : t('Individual Competition')}</div>
                                                    </div>
                                                    
                                                    
                                                </div> */}

                                                <div style={style.contentPic}>
                                                    <div style={style.segment}>
                                                    <img style={style.banner} alt='' src={season.leaderboard?.banner?.dataURL || season.leaderboard?.banner?.url || competition.banner?.url || defaultObjectiveImage} />

                                                    <Button type='button'
                                                        style={style.uploadPhoto}
                                                        onClick={onUploadPhoto}>
                                                        {t('upload_photo_button_text')}
                                                    </Button>
{choosePhotoIsOpen && 
                                                    <ChoosePhotoContainer onConfirmPhoto={onConfirmPhoto}
                        width={1280}
                        height={720}
                        onClose={onUploadPhoto} />}
                                                    <div style={style.cardContent}>
                                                        
                                                    
                                                    <Tab
                                                        activeIndex={localeTabIndex}
                                                        onTabChange={onLocaleTabChange}
                                                        panes={languages.map(language => ({
                                                            menuItem: language.text,
                                                            render: () => (
                                                                <LanguagePane
                                                                    t={t}
                                                                    season={season}
                                                                    locale={language.value}
                                                                    seasonData={season?.locales?.[language.value]}
                                                                    competitionData={season.leaderboard?.locales?.[language.value]}
                                                                    competition={competition}
                                                                    onChange={onLanguageInputChange}
                                                                />
                                                            ),
                                                        }))}
                                                    />
                                                        <div style={{...style.h3, ...style.competitionTitle}}></div>
                                                        
                                                        <div style={style.h4}>Type</div>

                                                        <Icon style={season.leaderboard.type === 'teams' ? style.checkmarkDim : style.checkmark} name='user' /> <Checkbox label='Individual Challenge' radio checked={season.leaderboard.type === 'company'} style={style.slider} onChange={(e, p)=>{onChangeRankPoints(e, {value : p.value}, 'season.leaderboard.type')}} value={'company'} disabled={!!season.id} />
                                                        <br/>
                                                        <Icon style={season.leaderboard.type === 'teams' ? style.checkmark : style.checkmarkDim} name='users' /> <Checkbox label='Team Challenge' radio checked={season.leaderboard .type === 'teams'} style={style.slider} onChange={(e, p)=>{onChangeRankPoints(e, {value : p.value}, 'season.leaderboard.type')}} value={'teams'} disabled={!!season.id}  />
                                                        
                                                        { localStorage.master === 'true' &&  <><br /><br /><Checkbox className='green' label='Auto Enrol' toggle checked={season.autoStart == true} style={style.togglePacks} onChange={(e, p)=>{onChangeRankPoints(e, {value : p.checked}, 'season.autoStart'); if(p.checked == false )onChangeRankPoints(e, {value : p.checked}, 'season.autoStart')}} disabled={!!season.id} /> <Popup
                                                            trigger={<Icon name='question circle outline' />}
                                                            content={'Members are automatically added to the challenge when syncing during the active challenge period'}
                                                            position='bottom center'
                                                            wide='very'
                                                        /></> }

                                                        { localStorage.master === 'true' &&  <><br /><br />{season.id ? <span>Priority: {season.priority}</span> : <Input 
                                                            
                                                                  
                                                                    style={style.numberInput}
                                                                    name='priority'
                                                                    label='Priority' 
                                                                    type='number' value={season.priority} 
                                                                    onChange={(e, p)=>{onChangeRankPoints(e, p, 'season.priority')}} /> }</> }
                                                        
                                                        <div style={style.h4}>Community Feed</div>

                                                        <Checkbox className='green' label='Enable Community Feed' toggle checked={season.hasFeed == true} style={style.togglePacks} onChange={(e, p)=>{onChangeRankPoints(e, {value : p.checked}, 'season.hasFeed'); if(p.checked == false )onChangeRankPoints(e, {value : p.checked}, 'season.feed.allowAssets')}} disabled={!!season.id} />

                                                        <Checkbox className='green' label='Allow Images on Community Feed (Note: Optimity does not moderate images for inappropriate content)' toggle checked={season.feed?.allowAssets === true} style={style.togglePacks} onChange={(e, p)=>{onChangeRankPoints(e, {value : p.checked}, 'season.feed.allowAssets')}} disabled={!!season.id || !season.hasFeed} />

                                                    </div>
                                                    </div>
                                            </div>
                                        
                                            {false && season.active && <Message warning>
                                                <Message.Header>This challenge is live!</Message.Header>
                                                <p>You cannot modify challenges once they are live. You may either delete the challenge or end the challenge early if desired.</p>
                                            </Message>}

                                    {categories && <div>
                                        <div style={style.h4}>{t('Applicable Categories')}</div>
                                        { categories.length > 0 && <Card.Group>{categories.map(a => {
                                                return <CategoryCard category={a} key = {a.id} onToggleCategory={onToggleCategory} />
                                        })}</Card.Group> || "(None)" }
                                    </div>}

                                    <div>
                                    <div style={style.h4}>{t('Teams')}</div>
                                    <div><Checkbox className='green' label='Segmented' toggle checked={season.leaderboard.type === 'teams' || season.isSegmented} style={style.togglePacks} onChange={(e, p)=>onChangeRankPoints(e, {value : p.checked}, 'season.isSegmented')} disabled={!!season.id} /><br /><br /></div>

                                    { !season.id && (season.leaderboard .type === 'teams' || season.isSegmented) && <div style={style.columnContainer}>
                                        <div style={style.leftColumn}>
                                            <div>{t('add_segmentteam_prompt')}</div>
                                            <Input placeholder={t('search_placeholder')}  onChange={onChangeSearch} fluid />


                                            {Boolean(!loadingTeamSegments) &&
                                            <ul style={style.segmentList}>
                                                {teamsSegments.map((segment,i) => (
                                                    <li key={segment.id} style={{...style.segmentRow, ...(i==0 && {borderTop:'none'}) }}>
                                                        {Boolean(!segment.segmentQueryId) ? (
                                                                <Icon name='user' title={t('in_team_hover')} />
                                                            ) : (
                                                                <Icon name='user' title={t('no_team_hover')} />
                                                        )}
                                                        <Button type="button" style={style.addButton} onClick={()=>onAddSegmentTeam(segment)}>
                                                            <Icon name='add' />
                                                        </Button>
                                                        <div style={style.segmentName}>
                                                            {segment.name && <div>{segment.name}</div>}
                                                            {Boolean(segment.segmentQueryId) ? ( "Segment" ) : ( "Team" )}
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                            }
                                            {Boolean(loadingTeamSegments) &&
                                                <div style={style.loaderWrapper}>
                                                    <LoadInline centered vcentered className="notInDimmer" style={style.loader} />
                                                </div>
                                            }
                                            
                                        </div>
                                        <div style={style.rightColumn}>
                                            <div>{t('segmentteam_prompt')}</div>
                                            <ul style={style.teamMemberList}>
                                            {addedTeamsSegments.map((segment,i) => (
                                                <li key={segment.id} style={{...style.teamSegmentRow, ...(i==0 && {borderTop:'none'}) }}>
                                                    <Button type="button" style={style.removeTeamSegmentButton} onClick={()=>onRemoveSegmentTeam(segment)}>
                                                        <Icon name='trash' />
                                                    </Button>
                                                    <div style={style.segmentName}>
                                                        {segment.name && <div>{segment.name}</div>}
                                                        {Boolean(segment.segmentQueryId) ? ( "Segment" ) : ( "Team" )}
                                                    </div>
                                                    
                                                </li>
                                            ))}
                                            </ul>
                                        </div>
                                    </div> }

                                    { season.id && season.seasonTeams?.length > 0 &&
                                    <div>
                                        <div style={style.h4}>{t('Teams')}</div>
                                        { season.seasonTeams.map((seasonTeam, index) => {
                                            return <div>{seasonTeam.team.name}</div>
                                        }) }
                                    </div>
                                    }

                                    { localStorage.master === 'true' && competition &&
                                    <div style={{ marginTop: spacings.base }}>
                                        <div style={style.h4}>Season-linked quizzes</div>
                                        <p style={style.body}>Search survey templates and link them to this season. Saving updates the season–survey links only.</p>
                                        <Search
                                            fluid
                                            loading={!!surveySearchLoading}
                                            placeholder={t('search_placeholder')}
                                            onSearchChange={(e, { value }) => onSurveySearchChange(value)}
                                            onResultSelect={onAddSeasonQuizFromSurvey}
                                            results={surveySearchResults || []}
                                            value={surveySearchQuery || ''}
                                            minCharacters={2}
                                        />
                                        <ul style={{ ...style.segmentList, height: 'auto', maxHeight: '220px', marginTop: spacings.small }}>
                                            {(seasonQuizDraft || []).map(function (row, i) {
                                                var canUp = i > 0;
                                                var canDown = i < (seasonQuizDraft || []).length - 1;
                                                return (
                                                    <li key={row.surveyId} style={{ ...style.segmentRow, ...(i === 0 && { borderTop: 'none' }) }}>
                                                        <Button
                                                            type="button"
                                                            style={{ ...style.removeTeamSegmentButton, color: colors.themeBlue, marginRight: 6 }}
                                                            disabled={!canUp}
                                                            onClick={() => onMoveSeasonQuiz && onMoveSeasonQuiz(row.surveyId, 'up')}
                                                            title="Move up"
                                                        >
                                                            <Icon name="chevron up" />
                                                        </Button>
                                                        <Button
                                                            type="button"
                                                            style={{ ...style.removeTeamSegmentButton, color: colors.themeBlue, marginRight: 6 }}
                                                            disabled={!canDown}
                                                            onClick={() => onMoveSeasonQuiz && onMoveSeasonQuiz(row.surveyId, 'down')}
                                                            title="Move down"
                                                        >
                                                            <Icon name="chevron down" />
                                                        </Button>
                                                        <Button type="button" style={style.removeTeamSegmentButton} onClick={() => onRemoveSeasonQuiz(row.surveyId)}>
                                                            <Icon name="trash" />
                                                        </Button>
                                                        <div style={style.segmentName}>
                                                            {row.title && <div>{row.title}</div>}
                                                            {!row.title && <div>{'Survey ' + row.surveyId}</div>}
                                                            {row.tag && <div style={{ ...style.body, fontSize: fontSizes.small }}>{row.tag}</div>}
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                    }

                                    </div>

                                    

                                    <Grid >
                                        <Grid.Row>
                                            <Grid.Column width={16}>
                
                                                    <div style={style.h4}>{t('Target Milestones')}</div>

                                                    { season.leaderboard.type !== 'teams' && <Grid style={style.body}>{milestones.map(function(a, index) {
                                                        return <Grid.Row key={index} style={style.slimRow}>
                                                                <Grid.Column width={2} verticalAlign="middle"><Checkbox className='green' toggle checked={milestones[index].enabled} style={style.togglePacks} onChange={(e, p)=>onChangeRankPoints(e, {value : p.checked}, 'milestones['+index+'].enabled')} disabled={!!season.id} /></Grid.Column>
                                                                <Grid.Column width={6}>
                                                                    {/* <MileStone milestone={a} prop={'points'} index={index} edit={!season.id} onChangeRankPoints={onChangeRankPoints} t={t}/> */}
                                                                    <MileStone milestone={a} prop={'resources'} index={index} edit={!season.id} activeColumn={competition?.column} onChangeRankPoints={onChangeRankPoints} t={t} />
                                                                    <MileStone milestone={a} prop={'actions'} index={index} edit={!season.id} activeColumn={competition?.column} onChangeRankPoints={onChangeRankPoints } t={t}/>
                                                                    <MileStone milestone={a} prop={'activities'} index={index} edit={!season.id} activeColumn={competition?.column} onChangeRankPoints={onChangeRankPoints} t={t} />
                                                                    <MileStone milestone={a} prop={'steps'} index={index} edit={!season.id} activeColumn={competition?.column} onChangeRankPoints={onChangeRankPoints} t={t} />
                                                                    <MileStone milestone={a} prop={'glasses'} index={index} edit={!season.id} activeColumn={competition?.column} onChangeRankPoints={onChangeRankPoints} t={t} />
                                                                    <MileStone milestone={a} prop={'duration'} index={index} edit={!season.id} activeColumn={competition?.column} onChangeRankPoints={onChangeRankPoints} t={t} />
                                                                    <MileStone milestone={a} prop={'distance'} index={index} edit={!season.id} activeColumn={competition?.column} onChangeRankPoints={onChangeRankPoints} t={t} />
                                                                    <MileStone milestone={a} prop={'floors'} index={index} edit={!season.id} activeColumn={competition?.column} onChangeRankPoints={onChangeRankPoints}  t={t}/>
                                                                    <MileStone milestone={a} prop={'photos'} index={index} edit={!season.id} activeColumn={competition?.column} onChangeRankPoints={onChangeRankPoints} t={t} />
                                                                </Grid.Column>
                                                                <Grid.Column width={5} style={style.pointsCell}>
                                                                    {   localStorage.master === 'true' &&
                                                                        <div>
                                                                            {season.id ? <span><Icon style={style.starIcon} className="notClickable icon-star"/>{a.rewardPoints}</span> : <Input 
                                                                            icon={<Icon style={style.starIcon} className="notClickable icon-star"/>}
                                                                            iconPosition='left'
                                                                            style={style.numberInput}
                                                                            name='points' 
                                                                            input={<input size="2"/>}
                                                                            type='number' value={a.rewardPoints} 
                                                                            onChange={(e, p)=>{onChangeRankPoints(e, p, 'milestones['+index+'].rewardPoints')}} /> }
                                                                        </div>
                                                                    }
                                                                    
                                                                {/* </Grid.Column>
                                                                <Grid.Column width={3} style={style.pointsCell}> */}
                                                                <div>
                                                                    {season.id ? <span><Icon style={style.resourcesIcon} className="notClickable icon-Optimollar"/>{a.rewardResources}</span> : <Input 
                                                                    icon={<Icon style={style.resourcesIcon} className="notClickable icon-Optimollar"/>}
                                                                    iconPosition='left'
                                                                    style={style.numberInput}
                                                                    name='points' 
                                                                    input={<input  size="2"/>}
                                                                    type='number' value={a.rewardResources} 
                                                                    onChange={(e, p)=>{onChangeRankPoints(e, p, 'milestones['+index+'].rewardResources')}} /> }
                                                                </div>
                                                                {/* </Grid.Column>
                                                                <Grid.Column width={1} style={style.pointsCell}> */}
                                                                {   localStorage.master === 'true' &&
                                                                        <div>
                                                                    {season.id ? <span>R: {a.rewardActionId ?? "-"}</span> : <Input 
                                                                    style={style.numberInput}
                                                                    name='rewardActionId' 
                                                                    input={<input  size="2"/>}
                                                                    type='number' value={a.rewardActionId}
                                                                    placeholder='RewardActionId' 
                                                                    onChange={(e, p)=>{onChangeRankPoints(e, p, 'milestones['+index+'].rewardActionId')}} /> }
                                                                         </div>
                                                                    }
                                                                     {   localStorage.master === 'true' && <>
                                                                        <div>
                                                                            <span>Repeatable: <Checkbox className='green' toggle checked={milestones[index].repeatable} style={style.togglePacks} onChange={(e, p)=>onChangeRankPoints(e, {value : p.checked}, 'milestones['+index+'].repeatable')} disabled={!!season.id} /></span>
                                                                         </div>
                                                                         { milestones[index].repeatable === true &&  <div>
                                                                            {season.id ? <span>Repeat Max: {a.repeatMax ?? "Infinite"}</span> : <Input 
                                                                    style={style.numberInput}
                                                                    name='repeatMax' 
                                                                    input={<input  size="2"/>}
                                                                    type='number' value={a.repeatMax}
                                                                    placeholder='Max repeats' 
                                                                    onChange={(e, p)=>{onChangeRankPoints(e, p, 'milestones['+index+'].repeatMax')}} /> }
                                                                         </div>
                                                                        }
                                                                         </>
                                                                    }

                                                                    
                                                                </Grid.Column>
                                                            </Grid.Row>
                                                    })}
                                                    </Grid> || <em>({t('None')})</em> }
                                                     { !season.id && 
                                                                <Button style={{...style.button, width:'auto'}} onClick={onAddMilestone}>+ Add Milestone</Button>
                                                       }
                                            </Grid.Column>
                                            <Grid.Column width={8}>

                                                    <div style={style.h4}>{t('Ranking Bonuses')}</div>
                                                    { season.hasLeaderboard && season.leaderboard.type !== 'teams' && rewards && rewards.length ? <Grid style={style.body}>{rewards.map(function(a, index) {
                                                        return <Grid.Row key={index} style={style.slimRow}>
                                                            <Grid.Column width={2} verticalAlign="middle"><Checkbox className='green' toggle checked={competition.competitionRewards[index].enabled} style={style.togglePacks} onChange={(e, p)=>onChangeRankPoints(e, {value : p.checked}, 'competition.competitionRewards['+index+'].enabled')} disabled={!!season.id} /></Grid.Column>
                                                            <Grid.Column width={season.id ? 3:  2} verticalAlign={'middle'}>
                                                                #{a.rank || rewards.length + '+'}
                                                            </Grid.Column>
                                                            {   localStorage.master === 'true' &&
                                                                <Grid.Column width={season.id ? 4:  6} style={style.pointsCell}>
                                                                
                                                                    {season.id ? <span><Icon style={style.starIcon} className="notClickable icon-star"/>{a.rewardPoints}</span> : <Input 
                                                                    icon={<Icon style={style.starIcon} className="notClickable icon-star"/>}
                                                                    iconPosition='left'
                                                                    style={style.numberInput}
                                                                    name='points'
                                                                    input={<input style={style.inputStyle}/>}
                                                                    type='number' value={a.rewardPoints} 
                                                                    onChange={(e, p)=>{onChangeRankPoints(e, p, 'competition.competitionRewards['+index+'].rewardPoints')}} /> }
                                                                </Grid.Column>
                                                            }
                                                            <Grid.Column width={season.id ? 4:  6} style={style.pointsCell}>
                                                                {season.id ? <span><Icon style={style.resourcesIcon} className="notClickable icon-Optimollar"/>{a.rewardResources}</span> : <Input 
                                                                icon={<Icon style={style.resourcesIcon} className="notClickable icon-Optimollar"/>}
                                                                iconPosition='left'
                                                                style={style.numberInput}
                                                                input={<input style={style.inputStyle}/>}
                                                                name='points' 
                                                                type='number' value={a.rewardResources} 
                                                                onChange={(e, p)=>{onChangeRankPoints(e, p, 'competition.competitionRewards['+index+'].rewardResources')}} /> }
                                                            </Grid.Column>
                                                        </Grid.Row>

                                                    })}</Grid> : <em>({t('None')})</em> }
                                                    <br />
                                                    <div style={style.h4}>{t('in_app_leaderboard_section')}</div>
                                                    <div><Checkbox className='green' label={t('in_app_leaderboard')} toggle checked={season.hasLeaderboard} style={style.togglePacks} onChange={(e, p)=>onChangeRankPoints(e, {value : p.checked}, 'season.hasLeaderboard')} /><br /><br /></div>
                                                    { season.hasLeaderboard && <div><Checkbox className='green' label={t('percentile_bands')} toggle checked={season.leaderboard?.rankMode === 'percentile'} disabled={!!season.id} style={style.togglePacks} onChange={(e, p)=>onChangeRankPoints(e, {value : p.checked ? 'percentile' : null}, 'season.leaderboard.rankMode')} /><br /><br /></div> }
                                                    { competition?.column === 'distance' && <div>
                                                        <Input
                                                            style={style.numberInput}
                                                            type='number'
                                                            label={t('meters_per_revolution')}
                                                            labelPosition='right'
                                                            value={competition.distanceConfig?.metersPerRevolution ?? 6}
                                                            disabled={!!season.id}
                                                            onChange={(e, p)=>onChangeRankPoints(e, {value: { ...(competition.distanceConfig || {}), metersPerRevolution: p.value === '' ? '' : Number(p.value) }}, 'competition.distanceConfig')}
                                                        />
                                                        <br /><br />
                                                    </div> }
                                                    { localStorage.master === 'true' && season.hasLeaderboard && <div><Checkbox className='green' label={t('leaderboard_show_company_name')} toggle checked={season.leaderboard?.subtitle === 'company-name'} style={style.togglePacks} onChange={onChangeLeaderboardShowCompanyName} /><br /><br /></div> }
                                                    { localStorage.master === 'true' && <>
                                                        <div style={style.h4}>{t('shareable_leaderboard_section')}</div>
                                                        <div><Checkbox className='green' label={t('shareable_leaderboard_enable')} toggle checked={!!season.leaderboard?.shareable} style={style.togglePacks} onChange={onChangeShareableLeaderboard} /><br /><br /></div>
                                                        { season.leaderboard?.shareable && <>
                                                        <Tab
                                                            activeIndex={localeTabIndex}
                                                            onTabChange={onLocaleTabChange}
                                                            panes={languages.map(language => ({
                                                                menuItem: language.text,
                                                                render: () => (
                                                                    <ShareableLanguagePane
                                                                        t={t}
                                                                        season={season}
                                                                        locale={language.value}
                                                                        onChange={onLanguageInputChange}
                                                                    />
                                                                ),
                                                            }))}
                                                        />
                                                        <div style={style.h4}>{t('share_tv_theme')}</div>
                                                        <div style={style.shareThemeColors}>
                                                            <div style={style.shareThemeColorField}>
                                                                <label>{t('share_color_progress_bar')}</label>
                                                                <Input fluid name='progressBarColor' placeholder='#RRGGBB' value={season.leaderboard?.displayTheme?.progressBarColor || ''} onChange={(e, p)=>onChangeRankPoints(e, {value: p.value}, 'season.leaderboard.displayTheme.progressBarColor')} />
                                                            </div>
                                                            <div style={style.shareThemeColorField}>
                                                                <label>{t('share_color_text')}</label>
                                                                <Input fluid name='textColor' placeholder='#RRGGBB' value={season.leaderboard?.displayTheme?.textColor || ''} onChange={(e, p)=>onChangeRankPoints(e, {value: p.value}, 'season.leaderboard.displayTheme.textColor')} />
                                                            </div>
                                                            <div style={style.shareThemeColorField}>
                                                                <label>{t('share_color_border_accent')}</label>
                                                                <Input fluid name='borderAccentColor' placeholder='#RRGGBB' value={season.leaderboard?.displayTheme?.borderAccentColor || ''} onChange={(e, p)=>onChangeRankPoints(e, {value: p.value}, 'season.leaderboard.displayTheme.borderAccentColor')} />
                                                            </div>
                                                            <div style={style.shareThemeColorField}>
                                                                <label>{t('share_color_checkmark')}</label>
                                                                <Input fluid name='checkmarkColor' placeholder='#RRGGBB' value={season.leaderboard?.displayTheme?.checkmarkColor || ''} onChange={(e, p)=>onChangeRankPoints(e, {value: p.value}, 'season.leaderboard.displayTheme.checkmarkColor')} />
                                                            </div>
                                                        </div>
                                                        <div style={style.shareThemeFlex}>
                                                            {[
                                                                { key: 'backgroundTop', label: t('share_background_top') },
                                                                { key: 'backgroundBottom', label: t('share_background_bottom') },
                                                                { key: 'backgroundBackground', label: t('share_background_full') },
                                                            ].map(({ key, label }) => {
                                                                const asset = season.leaderboard?.displayTheme?.[key];
                                                                const src = (typeof asset === 'string') ? asset : (asset?.dataURL || asset?.dataUrl || asset?.url);
                                                                return (
                                                                    <div key={key} style={style.shareThemeColumn}>
                                                                        {src && (
                                                                            <div style={{ position: 'relative' }}>
                                                                                <img style={style.shareThemePreview} src={src} alt='' />
                                                                                <Icon name='remove circle' style={{ position: 'absolute', top: 0, right: '1rem', cursor: 'pointer', fontSize: '1.5rem' }} onClick={() => onRemoveThemeAsset(key)} />
                                                                            </div>
                                                                        )}
                                                                        <h5>{label}</h5>
                                                                        <Button type='button' style={buttons.short} onClick={() => onUploadThemePhoto(key)}>{t('upload_image')}</Button>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </> }
                                                    </> }
                                            
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                    <div>
                                        <div style={style.h4}>{t('Duration')}</div>
                                        <Grid verticalAlign={'middle'} style={style.fullHeight} columns={13}>
                                            <Grid.Row>
                                                <Grid.Column style={style.noPadding} width={5}>
                                                    IANA Timezone
                                                </Grid.Column>
                                                <Grid.Column style={style.noPadding} width={6}>
                                                    {!season.id && <div>
                                                        <Dropdown
                                                            options={moment.tz.names().map((a)=>({key:a,text:a,value:a}))} 
                                                            value={season.timeZone}
                                                            search
                                                            fluid
                                                            selection
                                                            onChange={(ev, value)=>{onTimeZoneChange(value.value, 'season.timeZone')}}
                                                        />
                                                        <a href="https://time.is" target="_blank">Search for an IANA timezone</a>
                                                        <Popup
                                                            trigger={<Icon name='question circle outline' />}
                                                            content={<ol>
                                                                <li>Click the link.</li>
                                                                <li>Search for the desired location (by city is best).</li>
                                                                <li>Scroll down to the line that says "The IANA time zone identifier for ... is ..."</li>
                                                                <li>Search for that time zone identifier in the dropdown above.</li>
                                                            </ol>}
                                                            position='bottom center'
                                                            wide='very'
                                                        />
                                                    </div> || season.timeZone }
                                                </Grid.Column>
                                            </Grid.Row>
                                            <Grid.Row>
                                                <Grid.Column style={style.noPadding} width={5}>
                                                    Pre-Enrollment Date (Inclusive)
                                                </Grid.Column>
                                                <Grid.Column style={style.noPadding} width={6}>
                                                    {(!(now && season.preEnrollmentAt && new Date(season.preEnrollmentAt).getTime() < now.getTime()) || preEnrollNow) && (
                                                        <div style={{ marginBottom: 8 }}>
                                                            <Radio label={t('Specific date')} checked={!preEnrollNow} onChange={(e, { checked }) => onPreEnrollNowChange(e, { checked: false })} />
                                                            <Radio label={t('Now')} checked={!!preEnrollNow} onChange={(e, { checked }) => onPreEnrollNowChange(e, { checked: true })} style={{ marginLeft: 12 }} />
                                                        </div>
                                                    )}
                                                    {season.id && now && season.preEnrollmentAt && new Date(season.preEnrollmentAt).getTime() < now.getTime() && !preEnrollNow
                                                        ? moment.tz(season.preEnrollmentAt, season.timeZone).format('llll')
                                                        : <DateTimePicker
                                                            value={new Date(season.preEnrollmentAt || now)}
                                                            step={60}
                                                            readOnly={!!preEnrollNow}
                                                            onChange={(value)=>onDateChange(value, 'season.preEnrollmentAt')}
                                                            onKeyPress={(event)=>{event.preventDefault()}}
                                                            max={preEnrollNow ? undefined : new Date(season.startsAt)}
                                                            min={preEnrollNow ? undefined : now}
                                                        />
                                                    }
                                                </Grid.Column>
                                            </Grid.Row>
                                            <Grid.Row>
                                                <Grid.Column style={style.noPadding} width={5}>
                                                    Start Date (Inclusive)
                                                </Grid.Column>
                                                <Grid.Column style={style.noPadding} width={6}>
                                                    {(!(now && season.startsAt && new Date(season.startsAt).getTime() < now.getTime()) || startNow) && (
                                                        <div style={{ marginBottom: 8 }}>
                                                            <Radio label={t('Specific date')} checked={!startNow} onChange={(e, { checked }) => onStartNowChange(e, { checked: false })} />
                                                            <Radio label={t('Now')} checked={!!startNow} onChange={(e, { checked }) => onStartNowChange(e, { checked: true })} style={{ marginLeft: 12 }} />
                                                        </div>
                                                    )}
                                                    {season.id && now && season.startsAt && new Date(season.startsAt).getTime() < now.getTime() && !startNow
                                                        ? moment.tz(season.startsAt, season.timeZone).format('llll')
                                                        : <DateTimePicker
                                                            value={new Date(season.startsAt || season.preEnrollmentAt || now)}
                                                            step={60}
                                                            readOnly={!!startNow}
                                                            onChange={(value)=>onDateChange(value, 'season.startsAt')}
                                                            onKeyPress={(event)=>{event.preventDefault()}}
                                                            max={startNow ? undefined : new Date(season.endsAt)}
                                                            min={startNow ? undefined : season.preEnrollmentAt}
                                                        />
                                                    }
                                                </Grid.Column>
                                            </Grid.Row>
                                            <Grid.Row>
                                                <Grid.Column style={style.noPadding} width={5}>
                                                    End Date (Exclusive)
                                                </Grid.Column>
                                                <Grid.Column style={style.noPadding} width={6}>
                                                    {(!(now && season.endsAt && new Date(season.endsAt).getTime() < now.getTime()) || endNow) && (
                                                        <div style={{ marginBottom: 8 }}>
                                                            <Radio label={t('Specific date')} checked={!endNow} onChange={(e, { checked }) => onEndNowChange(e, { checked: false })} />
                                                            <Radio label={t('Now')} checked={!!endNow} onChange={(e, { checked }) => onEndNowChange(e, { checked: true })} style={{ marginLeft: 12 }} />
                                                        </div>
                                                    )}
                                                    {season.id && now && season.endsAt && new Date(season.endsAt).getTime() < now.getTime() && !endNow
                                                        ? moment.tz(season.endsAt, season.timeZone).format('llll')
                                                        : <DateTimePicker
                                                            value={new Date(season.endsAt || season.startsAt || now)}
                                                            step={60}
                                                            readOnly={!!endNow}
                                                            onChange={(value)=>onDateChange(value, 'season.endsAt')}
                                                            onKeyPress={(event)=>{event.preventDefault()}}
                                                            min={endNow ? undefined : new Date(season.startsAt)}
                                                        />
                                                    }
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                    </div>

                                    {dateError && (
                                        <Message negative style={{ marginTop: 12 }}>
                                            {t(dateError)}
                                        </Message>
                                    )}

                                    { false && checkAccess(sections.EMAIL) && announcements && !!announcements.length && <div>
                                        <div style={style.h4}>{t('Campaign Messaging')}</div>
                                        { announcements.map((announcement, index) => <Grid verticalAlign={'middle'} key={announcement.id || index} style={style.fullHeight} columns={13}>
                                            <Grid.Row>
                                                {!season.id && <Grid.Column textAlign={'center'} style={style.noPadding} width={2}>
                                                    <Checkbox className='green' style={style.togglePacks} toggle checked = {announcement.enabled}  onClick={(e, p)=>{onChangeCheckbox(e, p, 'announcements['+index+'].enabled')}}/>
                                                </Grid.Column> }
                                                <Grid.Column style={style.noPadding} width={5}>
                                                    {announcementTypes[announcement.type].label}
                                                    <Popup
                                                        trigger={<Icon name='question circle outline' />}
                                                        content={announcementTypes[announcement.type].info}
                                                        position='right center'
                                                    />
                                                </Grid.Column>
                                                <Grid.Column style={style.noPadding} width={6}>
                                                    {!season.id && <DateTimePicker
                                                        value={new Date(announcement.sendAt)}
                                                        step={30}
                                                        readOnly={!!season.id}
                                                        onChange={(value)=>onDateChange(value, 'announcements['+index+'].sendAt')}
                                                        onKeyPress={(event)=>{event.preventDefault()}}
                                                        max={announcementTypes[announcement.type].getMax(season)}
                                                        min={announcementTypes[announcement.type].getMin(season)}
                                                    /> || moment.tz(announcement.sendAt, season.timeZone).format("llll") }
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid> )}
                                    </div> }

                                    <DeletePromptContainer ref = {deleteModalRef} onDeleteConfirmation = {onDelete}/>
                                    
                                    
                                    <Grid style={style.buttonsRow}>
                                        <Grid.Row columns={'equal'}>
                                            { season.id && <Grid.Column>  
                                                <Button style={buttons.delete} onClick={() => {deleteModalRef.current.showDeletePrompt()}} disabled={uploading}> {season && t('Delete Season')}</Button>
                                            </Grid.Column> }
                                            <Grid.Column style={style.gridSubmit}>{ uploading && 'Saving...' }
                                                {!season.id && <Button style={style.button} onClick={onSubmit} disabled={uploading}> {t('Schedule Competition')}</Button>}
                                                {season.id && <Button style={style.button} onClick={onSubmit} disabled={uploading}>{t('Update Competition')}</Button>}
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </div>
                            }
                        </div>
                    }
                </Modal.Description>
            </Modal.Content>
        </Modal>
);
}
export default withTranslation('competitions')(EditCompetitionModal);
